import { Controller } from 'react-hook-form'
import classNames from 'classnames'
import { SelectPicker } from 'rsuite'
import { isValidators } from '../../utils/ValidatorUtils'
import { isEmpty } from 'lodash-es'

export default function EditSelectCell({
  id,
  rowSchema,
  rowData,
  dataKey,
  register,
  control,
  errors,
  defaultValue,
  onChangeCell = () => {},
  cleanable = true,
  disabled = false,
  disabledItemValues = [],
  searchable = false,
  isEdit = false,
  isArray = false,
  ...props
}) {
  const editing = rowData.status === 'EDIT' || isEdit
  const _id = id || rowData.id

  return (
    <span {...props} className={editing ? 'table-content-editing' : ''}>
      {editing ? (
        <Controller
          name={_id}
          control={control}
          defaultValue={defaultValue || rowData[dataKey] || rowSchema?.optionSelected || ''}
          //rules={!disabled && { required: `กรุณากรอก${rowSchema?.label}` }}
          rules={!disabled && isValidators(rowSchema?.validators)}
          render={(props) => {
            return (
              <SelectPicker
                className={classNames(
                  isArray
                    ? !props.value && errors[dataKey] && 'is-error-cell'
                    : errors[_id] && 'is-error-cell'
                )}
                //menuClassName={rowSchema?.options.length > 8 ? 'custom-picker-menu-item-width' : ''}
                data={rowSchema?.options}
                value={props.value}
                block
                virtualized={false}
                searchable={searchable}
                placeholder={errors[dataKey] || errors[_id] ? 'กรุณาเลือก' : 'เลือก'}
                cleanable={cleanable}
                disabled={disabled}
                disabledItemValues={disabledItemValues}
                onChange={(value) => {
                  props.onChange(value)
                  onChangeCell(value)
                }}
              />
            )
          }}
        />
      ) : (
        <span>{rowData[dataKey]}</span>
      )}
    </span>
  )
}
